export const Brands_Images = [
  "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Amazon_logo.svg/905px-Amazon_logo.svg.png",
  "https://www.itln.in/h-upload/2022/04/29/25071-flipkart1.webp",
  "https://upload.wikimedia.org/wikipedia/en/thumb/d/d5/Myntra_logo.png/330px-Myntra_logo.png",
  "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/Walmart_logo.svg/330px-Walmart_logo.svg.png",
  "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1b/EBay_logo.svg/330px-EBay_logo.svg.png",
];
